
/**
 * 강좌 가격 정보
 * @nullable
 */
export type CourseDetailSummaryPrice = {
  /** 가격 금액 */
  amount: number;
  /** 통화 코드 (ISO 4217) */
  currency: string;
} | null;
